export default __webpack_public_path__ + "static/AN_Loop_h265-3f4205c83b6f4f51f4c495adf15c8bfa.mp4";